import Button from "@lhd/components/Button";
import { IPermissionItem } from "@lhd/types";
import { Form } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { useEffect, useRef } from "react";

export interface ButtonToSaveProps {
  form: FormInstance;
  isEditing?: boolean;
  permission?: IPermissionItem;
  isUploading?: boolean;
  hasChanged: boolean;
  setHasChanged: (v: boolean) => void;
  dataVersion: number;
}

const ButtonToSave = ({
  form,
  isEditing,
  permission,
  isUploading,
  hasChanged,
  setHasChanged,
  dataVersion,
}: ButtonToSaveProps) => {
  return (
    <Button
      disabled={!isEditing || !permission?.edit || !hasChanged || !!isUploading}
      label="上書き保存"
      onClick={form.submit}
    />
  );
};

export default ButtonToSave;
